import { fetchSoldHoldings } from 'views/Portfolio/components/Details/services/fetchSoldHoldings';
import { formatCurrency } from '../../../AIChat/utils/formatters';

export const buildTransactionContext = async (): Promise<string> => {
  const response = await fetchSoldHoldings({ limit: 100 });

  if (!response.data || response.data.length === 0) {
    return 'No transaction history available.';
  }

  const holdings = response.data;
  const lines: string[] = [];

  // Summary stats
  const totalTransactions = holdings.length;
  const totalSalesValue = holdings.reduce((sum, h) => sum + (h.totalValue || 0), 0);
  const totalPL = holdings.reduce((sum, h) => sum + (h.profitAndLoss || 0), 0);
  const profitableCount = holdings.filter((h) => (h.profitAndLoss || 0) > 0).length;
  const lossCount = holdings.filter((h) => (h.profitAndLoss || 0) < 0).length;
  const winRate = totalTransactions > 0 ? (profitableCount / totalTransactions) * 100 : 0;

  lines.push('## Transaction History (Previously Sold Wines)');
  lines.push('');
  lines.push('### Trading Behavior Summary');
  lines.push(`- Total Transactions: ${totalTransactions}`);
  lines.push(`- Total Sales Value: ${formatCurrency(totalSalesValue)}`);
  lines.push(`- Total P&L: ${formatCurrency(totalPL)}`);
  lines.push(`- Win Rate: ${winRate.toFixed(0)}% (${profitableCount} profitable, ${lossCount} losses)`);
  lines.push('');

  // Regional breakdown
  const regionMap = new Map<string, { count: number; totalValue: number; avgPL: number }>();
  holdings.forEach((h) => {
    const region = h.cultWinesAllocationRegion || 'Unknown';
    const existing = regionMap.get(region) || { count: 0, totalValue: 0, avgPL: 0 };
    existing.count += 1;
    existing.totalValue += h.totalValue || 0;
    existing.avgPL += h.profitAndLoss || 0;
    regionMap.set(region, existing);
  });

  lines.push('### Regional Trading Preferences');
  Array.from(regionMap.entries())
    .sort((a, b) => b[1].count - a[1].count)
    .slice(0, 8)
    .forEach(([region, data]) => {
      lines.push(`- ${region}: ${data.count} transactions, ${formatCurrency(data.totalValue)}`);
    });
  lines.push('');

  // Top profitable trades
  const sortedByPL = [...holdings]
    .filter((h) => (h.profitAndLoss || 0) > 0)
    .sort((a, b) => (b.profitAndLoss || 0) - (a.profitAndLoss || 0))
    .slice(0, 5);

  if (sortedByPL.length > 0) {
    lines.push('### Most Profitable Trades');
    sortedByPL.forEach((h) => {
      lines.push(`- ${h.wineName || h.lwin18} ${h.vintage || ''}: +${formatCurrency(h.profitAndLoss || 0)}`);
    });
  }

  return lines.join('\n');
};
